import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {Globals} from '../../../../../core/services/globals';
import {AbstractListingsSearchComponent} from '../../../../../shared/components/listing-search/abstract-listings-search.component';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'my-peelhalton-listing-search',
  templateUrl: './peelhalton-listing-search.component.html',
  styleUrls: ['../../../../../shared/components/listing-search/listing-search.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule], // ✅ Add FormsModule here
})
export class PeelHaltonListingsSearchComponent extends AbstractListingsSearchComponent {

  public isPeelSite = true;

  constructor(router: Router, globals: Globals) {
    super(router, globals);
  }

  /**
   * Provide Peel Halton-specific default areas.
   */
  protected getDefaultAreas(): { name: string; value: string }[] {
    return [
      {name: 'All Of Peel & Halton', value: ''},
      {name: 'All Of Mississauga', value: 'Mississauga'},
      {name: 'Lakeview', value: 'Lakeview'},
      {name: 'Mineola', value: 'Mineola'},
      {name: 'Port Credit', value: 'Port Credit'},
      {name: 'Lorne Park', value: 'Lorne Park'},
      {name: 'Clarkson', value: 'Clarkson'},
      {name: 'Etobicoke', value: 'Etobicoke'},
      {name: 'Burlington', value: 'Burlington'},
      {name: 'Oakville', value: 'Oakville'},
    ];
  }
}
